import script from "./AddOnhireAncillaryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AddOnhireAncillaryComponent.vue?vue&type=script&setup=true&lang=js"

import "./AddOnhireAncillaryComponent.vue?vue&type=style&index=0&id=6b79cd6c&lang=css"

const __exports__ = script;

export default __exports__